import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setPostUpdatePoints = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_POINTS_UPDATE_TOURNAMENT
            });
            dispatch(Action.SetGetViewTournamentStat({
                id_tournament: params.id_tournament
            }))
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostUpdatePoints as SetPostUpdatePoints
}